import React from 'react';
import CustomPaginate from '../../../../components/PaginateComponent';
import ToggleDropdown from '../../../../components/ToogleDropdown';
import InfoIcon from '../../../../SVG/InfoIcon';
import Tags from '../../../../components/Tag/Tags';
import { useNavigate } from 'react-router-dom';
import Archive from '../../../../SVG/Archive';
import Pencil from '../../../../SVG/Pencil';
import Active from '../../../../SVG/Active';
import {useTranslation} from '../../../../hooks/useTranslation';

const EquipmentTransfersTab = ({
  equipmentData,
  setCurrentId,
  currentId,
  handlePageClick,
  currentPage,
  handleUnAssign,
  handleActivate,
  handleArchive,
}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  return (
    <div className='equipment__box'>
      <table className='equipment__table'>
        <thead className='equipment__table-head'>
          <tr>
            <th>{t('equipmentTable.headers.type')}</th>
            <th>{t('equipmentTable.headers.id')}</th>
            <th>{t('equipmentTable.headers.facility')}</th>
            <th>{t('equipmentTable.headers.nfc')}</th>
            <th>{t('equipmentTable.headers.transferredDate')}</th>
            <th>{t('equipmentTable.headers.transferredFrom')}</th>
            <th>{t('equipmentTable.headers.by')}</th>
            <th>{t('equipmentTable.headers.status')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody className='equipment__table-body'>
          {equipmentData?.data?.length ? (
            equipmentData?.data
              ?.filter(el => el?.type?.id !== 44)
              ?.map((equipment, index) => (
                <React.Fragment key={equipment?.id}>
                  <tr key={equipment?.id} className='equipment__table-row'>
                    <td>
                      <p className='equipment__table-subtitle'>{equipment?.type?.title}</p>
                    </td>
                    <td>
                      <p className='equipment__table-subtitle'>{equipment?.title}</p>
                    </td>
                    <td>
                      <p className='equipment__table-subtitle'>
                        {equipment?.facility?.name}
                      </p>
                    </td>

                    <td className='s'>
                      <p className='equipment__table-title'>NFC</p>
                      {equipment?.beacon_address ? (
                        <p className='equipment__table-subtitle'>
                          <img src='/assets/icons/nfc-active.png' alt='icon' />
                          <img
                            src='/assets/icons/beacon-address.svg'
                            onClick={() => handleUnAssign(equipment)}
                            alt='icon'
                          />
                        </p>
                      ) : (
                        <p className='equipment__table-subtitle'>
                          <img src='/assets/icons/nfc-inactive.png' alt='icon' />
                        </p>
                      )}
                    </td>
                    <td>
                      <p className='equipment__table-subtitle'>
                        {equipment?.transferred_at ? equipment?.transferred_at : '---'}
                      </p>
                    </td>
                    <td>
                      <p className='equipment__table-subtitle'>
                        {equipment?.transferred_from_agency ? equipment?.transferred_from_agency : '---'}
                      </p>
                    </td>
                    <td>
                      <p className='equipment__table-subtitle'>
                        {equipment?.transferred_by_user ? equipment?.transferred_by_user : '---'}
                      </p>
                    </td>
                    <td>
                      <p className='equipment__table-subtitle'>
                        {
                          equipment?.transferred_in && <Tags text={'IN'} type={ equipment?.show_activate_transfer_in ? 'outlined' : 'IN'} />
                        }
                        {
                          equipment?.transferred_out && <Tags text={'OUT'} type='Out' />
                        }
                      </p>
                    </td>
                    <td>
                      <ToggleDropdown
                        index={index}
                        itemId={equipment?.id}
                        selectedItem={currentId}
                        setSelectedItem={setCurrentId}
                        showNdxId={false}
                      >
                        {
                          equipment?.transferred_out && (
                            <div className='equipment__table-btn blue' onClick={() => {
                              navigate(`/equipment/edit/${equipment?.id}`, {
                                state: { ...equipment, preview: true },
                              });
                            }}>
                              <InfoIcon color={'#999999'} />
                              {t('equipmentTable.actions.preview')}
                            </div>
                          )
                        }
                        {
                          equipment?.transferred_in && (
                            <>
                              <>
                                {
                                  equipment?.show_activate_transfer_in &&
                                  <div
                                    className='equipment__table-btn decom green'
                                    onClick={() => handleActivate(equipment)}
                                  >
                                    <Active color={'#999999'}/>
                                    {t('equipmentTable.actions.activate')}
                                  </div>
                                }
                              </>
                              <div className='equipment__table-btn blue' onClick={() => {
                                navigate(`/equipment/edit/${equipment?.id}`, {
                                  state: {equipment},
                                });
                              }}>
                                <Pencil color={'#999999'} />
                                {t('equipmentTable.actions.edit')}
                              </div>
                              <div className='equipment__table-btn danger red' onClick={() => handleArchive(equipment)}>
                                <Archive color={'#999999'} />
                                {t('equipmentTable.actions.archive')}
                              </div>
                            </>
                          )
                        }
                      </ToggleDropdown>
                    </td>
                  </tr>
                </React.Fragment>
              ))
          ) : (
            <tr className='equipment__table-row empty-row'>
              <td colSpan="9" className='equipment__table-empty'>
                <div className='equipment__table-empty-content'>
                  <img src='/assets/empty-list.png' alt='empty' />
                  <p>{t('equipmentTable.messages.noData')}</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <CustomPaginate
        pageCount={equipmentData?.pages}
        handlePageClick={handlePageClick}
        currentPage={currentPage}
      />
    </div>
  )
};

export default EquipmentTransfersTab;